// import store from '@/store'
const DocumentsRoutes = [
  {
    path: '/:prefix(test)?/documents/create',
    name: 'DocumentsCreate',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'DocumentsList',
      requireAuth: true,
      requireAccount: true,
      use: ['fc', 'ax'],
      // permissionsRequired: ['add_document'],
      title: 'Nuevo documento'
    },
    component: () => import('@/modules/documents/views/DocumentsCreate')
  },
  {
    path: '/:prefix(test)?/documents/create/pe',
    name: 'DocumentsCreatePE',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'DocumentsList',
      requireAuth: true,
      requireAccount: true,
      use: ['fc', 'ax'],
      title: 'Nuevo documento PE'
    },
    component: () => import('@/modules/documents/views/DocumentsCreatePE')
  },
  {
    path: '/:prefix(test)?/documents/:id/create/pe',
    name: 'DocumentsClonePE',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'DocumentsList',
      requireAuth: true,
      requireAccount: true,
      use: ['fc', 'ax'],
      title: 'Clonar documento PE'
    },
    component: () => import('@/modules/documents/views/DocumentsCreatePE')
  },
  {
    path: '/:prefix(test)?/documents',
    name: 'DocumentsList',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'DocumentsList',
      requireAuth: true,
      requireAccount: true,
      // permissionsRequired: ['view_document', 'add_document'],
      use: ['fc', 'ax'],
      title: 'Documentos'
    },
    component: () => import('@/modules/documents/views/DocumentsList')
  },
  {
    path: '/:prefix(test)?/documents/:id',
    name: 'DocumentsRetrieve',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'DocumentsList',
      requireAuth: true,
      requireAccount: true,
      use: ['fc', 'ax'],
      title: 'Información de documento'
    },
    component: () => import('@/modules/documents/views/Main')
  },
  {
    path: '/:prefix(test)?/documents/:id/create',
    name: 'DocumentsClone',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'DocumentsList',
      requireAuth: true,
      requireAccount: true,
      use: ['fc', 'ax'],
      title: 'Clonar documento'
    },
    component: () => import('@/modules/documents/views/DocumentsCreate')
  },
  {
    path: '/:prefix(test)?/batch/documents',
    name: 'DocumentsBatchListCreate',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'DocumentsList',
      requireAuth: true,
      requireAccount: true,
      use: ['ax', 'fc'],
      // permissionsRequired: ['view_batch', 'add_batch'],
      title: 'Emisión por lote'
    },
    component: () => import('@/modules/documents/batch/views/DocumentsBatchListCreate')
  },
  {
    path: '/:prefix(test)?/batch/documents/:id',
    name: 'DocumentsBatchRetrieve',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'DocumentsList',
      requireAuth: true,
      requireAccount: true,
      use: ['ax', 'fc'],
      // permissionsRequired: ['view_batch'],
      title: 'Detalles de facturación por lote',
      breadcrumbs: [
        {
          text: 'Emisión',
          to: { name: 'DocumentsBatchListCreate' },
          link: true,
          exact: true,
          disabled: false
        },
        {
          text: 'Emisión por lote',
          disabled: true
        }
      ]
    },
    component: () => import('@/modules/documents/batch/views/DocumentsBatchRetrieve')
  }
]
const list = () => {
  const env = process.env?.VUE_APP_MODE ?? 'ax'
  return DocumentsRoutes?.filter(({meta}) => meta?.use?.some((v) => v === env))
}
export default list()